import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase/app';
import 'firebase/firestore';
import _ from 'lodash';
import router from './router';

const config = {
  apiKey: 'AIzaSyDw52Dz5HVtxWSPxwgh0m3gUXus0NeXpAE',
  authDomain: 'stories-reader.firebaseapp.com',
  databaseURL: 'https://stories-reader.firebaseio.com',
  projectId: 'stories-reader',
  storageBucket: 'stories-reader.appspot.com',
  messagingSenderId: '866190017366',
  appId: '1:866190017366:web:04800094cdd2d1ba130cf7'
};

firebase.initializeApp(config);

// Initialize Cloud Firestore through Firebase
export const db = firebase.firestore();

// Disable deprecated features
db.enablePersistence({ tabSynchronization:true });

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    stories: [],
    authors: []
  },
  getters: {
    user: state => {
      return state.user
    },
    authors: state => {
      return state.authors
    },
    stories: state => {
      return state.stories
    }
  },
  actions: {
    fetchUser ({ commit,dispatch }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.email,
          email: user.email
        });
        dispatch('getAuthorsFromAPI');
        dispatch('getBooksFromAPI');
      } else {
        commit("SET_USER", null);
      }
    },
    logoutUser ({ commit }) {
      commit("SET_LOGGED_IN", false);
      commit("SET_USER", null);
    },
    getBooksFromAPI ({ commit }) {
      // eslint-disable-next-line no-undef
      NProgress.start();
      const docRef = db.collection("stories");
      let stories = [];
      docRef.orderBy("title").get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          stories.push({id: doc.id, data: doc.data()});
          // eslint-disable-next-line no-undef
          NProgress.done();
        });
        commit("SET_STORIES", stories);
      })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log("Error getting documents: ", error);
        });
    },
    getAuthorsFromAPI ({ commit }) {
      // eslint-disable-next-line no-undef
      NProgress.start();
      const docRef = db.collection("authors");
      let authors = [];
      docRef.orderBy("name").get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          authors.push({id: doc.id, data: doc.data()});
          // eslint-disable-next-line no-undef
          NProgress.done();
        });
        commit("SET_AUTHORS", authors);
      })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log("Error getting documents: ", error);
        });
    },
    markAsRead ({ commit }, storyId) {
      const readDate = new Date();
      const dbStory = db.collection('stories').doc(storyId);
      return dbStory.update({
        markAsRead: true,
        readDate: readDate
      })
        .then(function() {
          commit("MARK_AS_READ", {storyId, readDate});
          router.go(-1);
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          // eslint-disable-next-line no-console
          console.error("Error updating document: ", error);
        });
    },
    deleteStory ({commit}, storyId) {
      db.collection('stories').doc(storyId).delete()
        .then(function () {
        commit("DELETE_STORY", storyId);
          router.go(-1);
      }).catch(function(error) {
        // The document probably doesn't exist.
        // eslint-disable-next-line no-console
        console.error("Error updating document: ", error);
      });
    }
  },
  mutations: {
    MARK_AS_READ(state, payload) {
      state.stories = state.stories.map(story => {
        if (story.id === payload.storyId) {
          story.data.markAsRead = true;
          story.data.readDate = payload.readDate;
        }
        return story;
      });
    },
    DELETE_STORY(state, storyId) {
      state.stories = state.stories.filter(story =>
        story.id !== storyId
      );
    },
    SET_STORIES(state, data) {
      state.stories = data;
    },
    SET_AUTHORS(state, data) {
      state.authors = data;
    },
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    }
  }
});

export default store;
